export default "__VITE_ASSET__cf49bcc3__"